import React from 'react'

const DividerIcon = () => {
  return (
    <svg
      width="1"
      height="38"
      viewBox="0 0 1 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="1" height="38" fill="#E6E7EA" />
    </svg>
  )
}

export default DividerIcon
